import { Carousel, Container, Row, Col } from "react-bootstrap";
import sh1 from "Media/pol1.jpg";
import sh2 from "Media/pol2.jpg";
import sh3 from "Media/pol3.jpg";

import { useTranslation } from "react-i18next";
import YouTube from "react-youtube";
function Gridas() {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 style={{ textAlign: "center" }}>{t("Gridas")}</h4>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <p style={{ textAlign: "center" }}>{t("Gridas_text1")}</p>
            <ul>
              <li>{t("Gridas_li1")}</li>
              <li>{t("Gridas_li2")}</li>
              <li>{t("Gridas_li3")}</li>
              <li>{t("Gridas_li4")}</li>
              <li>{t("Gridas_li5")}</li>
              <li>{t("Gridas_li6")}</li>
              <li>{t("Gridas_li7")}</li>
            </ul>
          </Col>
          <Col xl={6} className="my-3">
            <YouTube
              videoId="rBfDSIzZPsA"
              containerStyle={{ minHeight: "300px" }}
              className="w-100 h-100"
              containerClassName="w-100 h-100"
            />
          </Col>
        </Row>
        <Row className="pb-5 px-3 justify-content-center">
          <Col lg={8} className="my-3">
            <Carousel style={{ maxHeight: "90vh", objectFit: "cover" }}>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh1} alt="First slide" />
                <Carousel.Caption>
                  <h3>{t("Gridas_slide1")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh2} alt="Second slide" />

                <Carousel.Caption>
                  <h3>{t("Gridas_slide2")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item style={{ maxHeight: "90vh", objectFit: "cover" }}>
                <img className="d-block w-100" style={{ maxHeight: "90vh", objectFit: "cover" }} src={sh3} alt="Third slide" />

                <Carousel.Caption>
                  <h3>{t("Gridas_slide3")}</h3>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export { Gridas };
